import { useMediaQuery } from 'react-responsive';

type Props = {
	children: any;
};

export const Desktop = ({ children }: Props) => {
	const isDesktop = useMediaQuery({ minWidth: 1200 });
	return isDesktop ? children : null;
};

export const Mobile = ({ children }: Props) => {
	const isTablet = useMediaQuery({ maxWidth: 1199 });
	return isTablet ? children : null;
};

export const Default = ({ children }: Props) => {
	const isNotMobile = useMediaQuery({ minWidth: 768 });
	return isNotMobile ? children : null;
};

export const useSizes = () => {
	const isDesktop = useMediaQuery({ query: '(min-width: 1200px)' });
	const isMobile = useMediaQuery({ query: '(max-width: 1199px)' });
	return { isDesktop, isMobile };
};
